import { useEffect } from "react";
import { useUpsertAuctionWatcherMutation } from "../../api/auctionApiSlice";

type AuctionWatcherWrapperProps = {
    auctionId: string;
    userId?: string;
};

export const MUTATION_INTERVAL_MS = 15 * 1000; // 15 seconds

function AuctionWatcherWrapper({
    auctionId,
    userId
}: AuctionWatcherWrapperProps) {
    const [upsertAuctionWatcherMutation] = useUpsertAuctionWatcherMutation();

    // If there is an authenticated user, hit the endpoint in an interval to log the user as online
    useEffect(() => {
        // Hit immediately on render if there's a user
        if (userId) {
            upsertAuctionWatcherMutation(auctionId);
        }

        // Hit every 15 seconds to keep the user online
        const interval = setInterval(() => {
            if (userId) {
                upsertAuctionWatcherMutation(auctionId);
            }
        }, MUTATION_INTERVAL_MS);
        return () => clearInterval(interval);
    }, [upsertAuctionWatcherMutation, auctionId, userId]);

    return <></>;
}

export default AuctionWatcherWrapper;
